export type HitVerdict = 'false_positive' | 'true_positive' | 'unknown';

export const HIT_VERDICT_LABELS: Record<HitVerdict, string> = {
  true_positive: 'True positive',
  false_positive: 'False positive',
  unknown: 'Unknown',
};

export interface IdentityFieldDiff {
  field: string;
  subject: string;
  matched: string;
  status: 'match' | 'partial' | 'mismatch' | 'unknown';
}

export type HitRecordKind =
  | 'PEP_POSITION'
  | 'SANCTION'
  | 'ARTICLE'
  | 'IDENTIFIER'
  | 'SOURCE'
  | 'PROFILE';
export interface HitRecordField {
  k: string;
  v: string;
}
export interface HitRecord {
  id: string;
  kind: HitRecordKind;
  title: string;
  meta: string;
  url?: string;
  fields?: HitRecordField[];
  snippet?: string;
  body?: string[];
}

export type RawVerdictStatus =
  | 'false_positive'
  | 'true_positive'
  | 'unknown'
  | 'potential_match'
  | 'no_match';

export interface CaseHit {
  id: string;
  matchedName: string;
  verdict: HitVerdict;
  rawStatus?: RawVerdictStatus;
  hitTypes: string[];
  whitelisted?: boolean;
  botReasoning?: string;
  evidence?: string[];
  diff?: IdentityFieldDiff[];
  records?: HitRecord[];
}

export interface CaseIdentityName {
  givenName: string;
  middleName?: string;
  familyName: string;
}
export interface CaseIdentityDetails {
  name: CaseIdentityName;
  dateOfBirth: string;
  address: string;
}

export interface CaseDetail {
  amlReviewId: string;
  externalProfileId: string;
  externalCheckId: string;
  accountId?: string;
  partnerName: string;
  kycProvider: 'frankieOne' | 'sumsub';
  region: string;
  reviewStatus: 'needs_review' | 'done';
  providerCaseUrl: string;
  zendeskCaseUrl?: string;
  supersedingAmlReviewId?: string;
  createdAt: string;
  identityDetails: CaseIdentityDetails;
  hits: CaseHit[];
  recommendation?: 'PASS' | 'REVIEW';
  summary?: string;
}

export function fullName(name: CaseIdentityName): string {
  return [name.givenName, name.middleName, name.familyName].filter(Boolean).join(' ');
}

export function formatDate(iso: string): string {
  const [year, month, day] = iso.split('-');
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  return `${Number(day)} ${monthNames[Number(month) - 1]} ${year}`;
}
